$(() => {
    const $mapWrapper = $('.map-parking');
    const $map = $mapWrapper.find('#map-parking');
    const $popup = $mapWrapper.find('.map-parking__map-modal');
    const $popupInner = $popup.find('.map-parking__popup-inner');
    const $popupContent = $popup.find('.map-parking__popup-content');
    const $popupClose = $popup.find('.map-parking__modal-close');
    let isOpenPopup = $popup.hasClass('map-parking__map-modal_opened');
    const $pointInfoTemplates = $mapWrapper.find('.map-parking__templates-parking-info');
    let idPopupInfo = -1;
    let heightLast;

    if ($map.length > 0) {
        ymaps.ready(function () {
            const collections = {};
            let zoom;

            if($(window).innerWidth() > 1024) {
                zoom =  16;
            } else {
                zoom =  15;
            }

            const map = new ymaps.Map('map-parking', {
                center: [60.796637, 56.751994,],
                zoom: zoom,
                controls: []
            }, {
                maxZoom: 17,
                minZoom: 14
                // yandexMapDisablePoiInteractivity: true
            }),
            objectManager = new ymaps.ObjectManager();

            //отключение зума карты колесиком мыши
            map.behaviors.disable('scrollZoom');

            map.controls
                .add('zoomControl', {
                    size: "small"
                });

            //инициализация пинов и полигонов на карте
            const createPlacemark = (point) => {
                const iconLayout  = ymaps.templateLayoutFactory.createClass(''+
                    '<div class="map-parking__point ' +
                    '{% if properties.name %} map-parking__point_{{properties.name}}{% endif %}' +
                    ' {% if properties.mod %}map-parking__point_{{properties.mod}}{% endif %}"' +
                    'id="figura-{{properties.id}}">' +
                        '{% if properties.content %}<span class="">{{properties.content}}</span>{% endif %}' +
                        '{% if properties.iconImageHref %}<object class="map-parking__point-icon" data="./images/content/svg/icon-{{properties.iconImageHref}}.svg" type="image/svg+xml"></object>{% endif %}' +
                    '{% if properties.hintContent %}<span class="map-parking__point-hint" data-for="figura-{{properties.id}}">{{properties.hintContent}}</span>{% endif %}' +

                    '</div>');


                const iconShape = (type) => {

                    let iconShape;

                    const circle = {
                        type: 'Circle',
                        coordinates: [0, 0],
                        radius: 20
                    };

                    const rectangle = {
                        type: 'Rectangle',
                        coordinates: [
                            [-25, -20], [25, 20]
                        ]
                    };

                    switch (type) {
                        case 'circle':
                            return circle;
                            break;

                        case 'terminal':
                            return rectangle;
                            break;

                        default:
                            return {}
                    }
                };

                const placemark = new ymaps.Placemark(point.geometry.coordinates, {
                        id: point.id,
                        name: point.geometry.icon.name,
                        mod: point.geometry.icon.mod,
                        content: point.geometry.icon.content,
                        iconImageHref: point.geometry.icon.image,
                        hintContent: point.geometry.icon.hintContent
                    }, {
                        iconLayout: iconLayout,
                        hintLayout: false,
                        iconShape: iconShape(point.geometry.icon.mod)
                    });

                const getPositionHint = (hint) => {
                    if(hint.offset().left + hint.innerWidth() >= $(window).innerWidth()) {
                        hint.css({
                            left: '-10px',
                            right: 'auto',
                            transform: 'translate(-100%)'
                        })
                    }
                };

                placemark.events
                    .add('mouseenter', function () {
                        const hint = $(`[data-for=figura-${point.id}]`);
                        if(!hint.length) return false;
                        getPositionHint(hint);
                        hint.addClass('active');
                    })
                    .add('mouseleave', function () {
                        const hint = $(`[data-for=figura-${point.id}]`);
                        if(!hint.length) return false;
                        hint.removeClass('active');
                    });
                return placemark;
            };

            const createPoligon = (poligon) => {

                const shape = new ymaps.Polygon(
                    poligon.geometry.coordinates,
                    {
                        hintContent: false,
                        itemData: 10
                    },
                    poligon.properties
                );

                return shape;
            };

            const addObjects = (object) => {
                const type = object.geometry.type;
                switch (type) {
                    case 'Polygon':
                        objectCurrent = createPoligon(object);
                        break;
                    default:
                        objectCurrent = createPlacemark(object);
                }

                let objectCurrent;

                return objectCurrent;
            };

            const createCollections= (data) => {
                const layers = data.layers;

                $.each(layers, (index, layer) => {
                    const objects = layer.features;

                    collections[layer.name] = new ymaps.GeoObjectCollection();

                    $.each(objects, (index, object) => {
                        const objectCurrent = addObjects(object);

                        collections[layer.name].add(objectCurrent);
                    });

                    map.geoObjects.add(collections[layer.name]);
                });

                $.each( Object.keys(collections), (index, collectionKey) => {
                    collections[collectionKey].events.add('click', (event) => {
                        if(!isOpenPopup) {
                            popupOpen(collectionKey);
                            changingInMap(collections, collections[collectionKey]);
                        } else {

                            if(idPopupInfo != collectionKey && (collectionKey.search('terminal') !== -1)) {
                                changeInPop(collectionKey);
                                changingInMap(collections, collections[collectionKey]);
                            }
                        }
                    });
                })
            };

            $.getJSON('data/parking-map.json')
                .done(function (json) {
                    // Добавляем описание объектов в формате JSON в менеджер объектов.
                    createCollections(json);
                });

            // функция появление попапа
            const popupOpen =(data) => {
                let timeout;

                idPopupInfo = data;
                const $template = $pointInfoTemplates.find(`[data="${data}"]`);
                $template.appendTo($popupContent);

                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    setPopupHeight('openPopup');
                    $popup.addClass('map-parking__map-modal_opened');
                    isOpenPopup = true;
                }, 50);
            };

            // функция закрытия попапа
            const popupClose =() => {
                let timeout;
                $popup.removeClass('map-parking__map-modal_opened');
                $popupContent.children().appendTo($pointInfoTemplates);
                idPopupInfo = -1;

                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    $popupContent.html('');
                }, 350);
                isOpenPopup = false;
            };

            //функция изменение данных в попапе
            const changeInPop =(data) => {
                let timeout;
                idPopupInfo = data;
                $popupContent.removeClass('show');
                $popupContent.addClass('hide');
                $popupContent.children().appendTo($pointInfoTemplates);

                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    $popupContent.html('');
                    const $template = $pointInfoTemplates.find(`[data="${data}"]`);
                    $template.appendTo($popupContent);
                    setPopupHeight('chancePopup');
                    $popupContent.removeClass('hide');
                    $popupContent.addClass('show');
                }, 350/2);
            };

            //функция изменение отображения в карте
            const changingInMap = (collections, currentCollections) => {

                //изменение масштаба карты
                const centerAndZoom = ymaps.util.bounds.getCenterAndZoom(

                    currentCollections.getBounds(),

                    map.container.getSize(),

                    map.options.get('projection')
                );

                if($(window).innerWidth() >= 768) {
                    map.setCenter(centerAndZoom.center, zoom, {
                        duration: 350,
                        checkZoomRange: true
                    });
                }
            };

            //изменение высоты попапа
            const setPopupHeight = (type) => {

                $popupInner.css('height', 'auto');
                const height = $popup.innerHeight();

                $popupInner.css('height', height);
            };


            $popupClose.click(() => {
                popupClose();
            });

            map.events.add('click', function (e) {
                popupClose();
                const targetObject = e.get('target');
            });

            $popup.on('getHeight', () => {
                setPopupHeight('chancePopup');
            });
        });
    }
});


// WEBPACK FOOTER //
// ./src/scripts/components/map-parking/index.js